import { useState } from "react";
import { Avatar, Skeleton } from "@mui/material";
import type { SxProps, Theme } from "@mui/material";

export function EmployeeAvatar(props: { src?: string; className?: string; sx?: SxProps<Theme> }) {
  const { src, className, sx } = props;
  const [imageResult, setImageResult] = useState<{ src: string; status: "loaded" | "error" }>();
  const imageStatus = imageResult?.src === src ? imageResult?.status : undefined;
  const isLoading = !!src && !imageStatus;

  return (
    <Avatar
      className={className}
      aria-busy={isLoading}
      data-testid="EmployeeAvatar"
      sx={[
        ...(Array.isArray(sx) ? sx : sx ? [sx] : []),
        {
          ...(isLoading ? { backgroundColor: "transparent" } : {}),
          "@media (prefers-reduced-motion: reduce)": {
            "& .MuiSkeleton-root, & .MuiSkeleton-root::after": { animation: "none" },
          },
        },
      ]}
    >
      {src && imageStatus !== "error" ? (
        <>
          <img
            key={src}
            src={src}
            alt=""
            onLoad={() => setImageResult({ src, status: "loaded" })}
            onError={() => setImageResult({ src, status: "error" })}
            style={{
              display: imageStatus === "loaded" ? "block" : "none",
              width: "100%",
              height: "100%",
              objectFit: "cover",
            }}
          />
          {isLoading && (
            <Skeleton
              variant="circular"
              width="100%"
              height="100%"
              data-testid="EmployeeAvatarSkeleton"
              sx={{ position: "absolute", inset: 0 }}
            />
          )}
        </>
      ) : undefined}
    </Avatar>
  );
}
